import { render, staticRenderFns } from "./KpiTable.vue?vue&type=template&id=65ebcfc2&scoped=true"
import script from "./KpiTable.vue?vue&type=script&lang=js"
export * from "./KpiTable.vue?vue&type=script&lang=js"
import style0 from "./KpiTable.vue?vue&type=style&index=0&id=65ebcfc2&prod&lang=scss&scoped=true"
import style1 from "./KpiTable.vue?vue&type=style&index=1&id=65ebcfc2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ebcfc2",
  null
  
)

export default component.exports